import * as React from "react";
const SvgInactiveEllipse = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 8, height: 8, viewBox: "0 0 8 8", fill: "none", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 4, cy: 4, r: 3.5, fill: "black", fillOpacity: 0.25, stroke: "white" }));
export default SvgInactiveEllipse;
